import axios from "axios";

type GetAllSupplierOrgResponse = {
    data?: [];
    error?: string;
} | null;

export const getAllSupplierOrg = async (): Promise<GetAllSupplierOrgResponse> => {
  try {
    const response = await axios.post(
    `${process.env.REACT_APP_PROXY_URL}/v1/fetchSupplierOrg`, null,
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response;
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response) {
      return { error: err?.response?.data?.message || "An error occurred" };
    }
      return { error: "An unexpected error occurred" };
    }
  };

export const supplierSearch = async (value: string) => {
  try {
    const response = await axios.post(
    `${process.env.REACT_APP_PROXY_URL}/v1/fetchSupplierOrg`, null,
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
        params: {
          search: value,
        }
      },
    );
    return response.data;
  } catch (err) {
    if (axios.isAxiosError(err) && err?.response) {
      return { error: err?.response?.data?.message || "An error occurred" };
    }
      return { error: "An unexpected error occurred" };
    }
  };
